import Personalizer from 'personalizer';
import {
    DASH,
    undefDash,
    undefEmpty,
    undefRank,
    percent,
    percentOfHundred,
    precisionToNumberFormat
} from './GolfNumberFormatter';
import NumberFormatter from 'utils/NumberFormatter';

export default {
    numberWithPlus: function(input, precision) {
        precision = precision || 0;
        if (isNaN(parseFloat(input))) {
            return DASH;
        }
        if (input == 0) {
            return 'E';
        }
        const numberSeparator = Personalizer.getNumberSeparator();
        const numberFormat = precisionToNumberFormat(precision);
        if (input >= 0) {
            return '+' + NumberFormatter(input, numberSeparator, numberFormat);
        }
        try {
            return NumberFormatter(input, numberSeparator, numberFormat);
        } catch (e) {
            return DASH;
        }
    },

    distanceUnitKey: function() {
        if (Personalizer.getGolfMeasurementSystem() === Personalizer.MeasurementSystems.METRIC) {
            return 'm';
        }

        return 'yds';
    },

    distanceUnitFullKey: function() {
        if (Personalizer.getGolfMeasurementSystem() === Personalizer.MeasurementSystems.METRIC) {
            return 'label_meters';
        }

        return 'label_yards';
    },

    zeroDash: function(input, precision) {
        precision = precision || 0;
        if (input && input !== '0' && input !== 0) {
            const numberSeparator = Personalizer.getNumberSeparator();
            const numberFormat = precisionToNumberFormat(precision);
            return NumberFormatter(input, numberSeparator, numberFormat);
        }

        return DASH;
    },

    zeroDashRawSlashHandicap: function(input, raw, precision) {
        if (input && input != '0' && input != 0) {
            if (raw && raw != '0' && raw != 0 && raw != input) {
                return this.fraction(parseFloat(raw).toFixed(precision), parseFloat(input).toFixed(precision));
            }
            return parseFloat(input).toFixed(precision);
        }

        return DASH;
    },

    percent: percent,

    percentOfHundred: percentOfHundred,

    undefDash: undefDash,

    undefEmpty: undefEmpty,

    undefRank: undefRank,

    personalizeDistance: function(num) {
        if (isNaN(parseFloat(num))) {
            return DASH;
        }
        if (Personalizer.getGolfMeasurementSystem() === Personalizer.MeasurementSystems.METRIC) {
            return num.toFixed(0);
        }

        num *= Personalizer.ConversionFactors.MetersToYards;
        return num.toFixed(0);
    },

    scoreName: function(parScore) {
        if (!parScore && parScore !== 0) {
            return '';
        }

        switch (Math.round(parScore)) {
            case -4:
                return 'Triple-Eagle';
                break;

            case -3:
                return 'Double-Eagle';
                break;

            case -2:
                return 'Eagle';
                break;

            case -1:
                return 'Birdie';
                break;

            case 0:
                return 'Par';
                break;

            case 1:
                return 'Bogey';
                break;

            case 2:
                return 'Double-Bogey';
                break;

            case 3:
                return 'Triple-Bogey';
                break;

            case 4:
                return 'Four-Over';
                break;

            case 5:
                return 'Five-Over';
                break;

            case 6:
                return 'Six-Over';
                break;

            default:
                return 'Way-Over';
                break;
        }
    },

    cityState: function(city, state) {
        var cityState = '';

        if (city) {
            cityState += city;
        }

        if (state) {
            if (cityState !== '') {
                cityState += ', ';
            }
            cityState += state;
        }

        return cityState;
    },

    streetCityStateCountry: function(street, city, state, country) {
        var cityState = this.cityState(city, state);

        if (street) {
            cityState = street + ' ' + cityState;
        }

        if (country) {
            cityState = cityState + ' ' + country;
        }

        return cityState;
    },

    fraction: function(numerator, denominator) {
        return numerator + '/' + denominator;
    },

    titleCase: function(str) {
        if (!str) {
            return '';
        }
        return str
            .split(' ')
            .map(function(val) {
                return val.charAt(0).toUpperCase() + val.substr(1).toLowerCase();
            })
            .join(' ');
    },

    dash: function() {
        return DASH;
    }
};
